import { useSalesTaxProductTaxCodesByCorporationId } from '@commenda/api';
import { useEffect, useState } from 'react';
import { FilterConfig } from '../../common/filters/types';

export const getProductFiltersConfig = (
  corporationId: number
): FilterConfig[] => {
  const [taxCodeOptions, setTaxCodeOptions] = useState<
    { value: string; label: string }[]
  >([]);

  const { data: taxCodes } = useSalesTaxProductTaxCodesByCorporationId({
    token: undefined,
    filters: { corporationId },
  });

  useEffect(() => {
    if (!taxCodes) return;

    setTaxCodeOptions(
      Array.isArray(taxCodes)
        ? taxCodes.map((code) => ({
            value: code.code || 'MISSING',
            label: code.code.replaceAll('_', ' ') || 'Missing',
          })).sort((a, b) => {
            // Missing should be at the top
            if (a.label === 'Missing') return -1;
            return a.label.localeCompare(b.label);
          })
        : []
    );
  }, [taxCodes]);

  return [
    {
      id: 'tax_codes',
      type: 'MULTIPLE',
      label: 'Product tax code',
      placeholder: 'Select product tax codes',
      options: taxCodeOptions,
    },
  ];
};
